import { render, staticRenderFns } from "./TabbarView.vue?vue&type=template&id=e0dd3d52&scoped=true&"
import script from "./TabbarView.vue?vue&type=script&lang=js&"
export * from "./TabbarView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dd3d52",
  null
  
)

export default component.exports